export default "__VITE_ASSET__IyfgFBVw__"